// extracted by mini-css-extract-plugin
export default {"form_heading":"DrawerHeading_form_heading__HjfSi","modal_right":"DrawerHeading_modal_right__92P4R"};